import React from 'react';
import ModeloHeaderMobile from './ModeloHeaderMobile';
import ModeloHeaderDesktop from './ModeloHeaderDesktop';

const ModeloHeaderWrapper = ({ nombre, serie, linea, descripcion, imagenUrl }) => {
  const isMobile = window.innerWidth < 768;

  const serieNombre = serie?.nombre || "Sin serie";
  const lineaNombre = linea?.nombre || "Sin línea";

  return (
    <>
      {isMobile ? (
        <ModeloHeaderMobile
          nombre={nombre}
          linea={lineaNombre} // Use processed linea nombre
          serie={serieNombre} // Use processed serie nombre
          descripcion={descripcion}
          imagenUrl={imagenUrl}
        />
      ) : (
        <ModeloHeaderDesktop
          nombre={nombre}
          linea={lineaNombre} // Use processed linea nombre
          serie={serieNombre} // Use processed serie nombre
          descripcion={descripcion}
          imagenUrl={imagenUrl}
        />
      )}
    </>
  );
};

export default ModeloHeaderWrapper;
